module.exports = require('./useOnyx')
